<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="col-12">
                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto  d-flex justify-content-end 
                                 order-1 order-md-2  mt-2  mb-2 mb-md-0">
                            <base-button @click="handleRefresh" size="sm" type="neutral">
                                <i class="fas fa-sync-alt"></i> Refresh
                            </base-button>
                            <button class="btn btn-link" @click="redirect">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <div class="col-12 col-md text-center order-2 order-md-1">
                            <h6 class="h2 mb-0">
                                {{ userName }} -
                                <span :class="{ 'text-green': totalPnL > 0, 'text-danger': totalPnL < 0 }">
                                    ₹{{ (totalPnL ?? 0).toFixed(2) }}
                                </span>
                            </h6>
                        </div>
                    </div>
                </div>
                <section>
                    <div v-if="positions?.length > 0" class="mt-2 row mt-lg-3">
                        <div class="mb-4 col-lg-6" v-for="(item, index) in groupedPositions" :key="index">
                            <trade-card :symbol="item.tradingInstrument" :term="item.tradeTerm"
                                :time="item.lastFetchedTime" :avg-price="item.avgPrice" :ltp="item.ltp"
                                :quantity="item.netQuantity" :pl="item.pl"
                                :orders="groupedEntryOrders[item.exchangeToken + '_' + getTradeName(item.tradeTerm)] || {}"
                                :exit-details="groupedEntryOrders[item.exchangeToken + '_' + getTradeName(item.tradeTerm)]?.exitPendingDetails || []"
                                :broker-quantity="groupedBrokerPositions[item.exchangeToken + '_' + getTradeName(item.tradeTerm)]?.netQuantity" />
                        </div>
                    </div>
                    <div v-else class="mt-2 row mt-lg-4 justify-content-center">
                        <h2 class=" text-warning">No positions available</h2>
                    </div>
                </section>
            </base-header>
        </div>
    </div>
</template>
<script>
import TradeCard from "./TradeCard.vue";
export default {
    name: "PositionDetails",
    data() {
        return {
            response: "",
            positions: [],
            brokerPositions: [],
            orders: [],
            userName: "",
            totalPnl: "",
            userId: "",
            analyticsData: {},
            refresh: false
        }
    },
    components: {
        TradeCard,
    },
    methods: {
        getTradeName(tradeTerm) {
            if (tradeTerm == "CARRYFORWARD" || tradeTerm == "NRML" || tradeTerm == "CNC" || tradeTerm == "OVERNIGHT"
                || tradeTerm == "NORMAL" || tradeTerm == "DELIVERY"
            ) {
                return 'OVERNIGHT';
            } else {
                return 'INTRADAY';
            }
        },
        async getAnalyticsDataByUserId() {
            try {
                let data = {
                    refresh: this.refresh,
                    userId: this.userId
                };
                const response = await this.$store.dispatch("analyticsDashboard/getAnalyticsDataById", data, { root: true })
                this.analyticsData = response.server.data;
            } catch (error) {
                console.error("Error fetching analytics data", error);
            }
        },
        redirect() {
            this.$router.push({ path: '/analyticsDashboard' });
        },
        async handleRefresh() {
            this.refresh = true;
            try {
                await this.getAnalyticsDataByUserId();
                this.positions = this.analyticsData?.positionBeans || [];
                this.brokerPositions = this.analyticsData?.brokerPositionBeans || [];
                this.orders = this.analyticsData?.orderBeans || [];
                this.totalPnL = this.positions.reduce((sum, pos) => sum + pos.pnl, 0);
            } catch (error) {
                console.error(error);
            }
            this.refresh = false;
        }
    },
    computed: {
        groupedPositions() {
            const result = {};
            (this.positions || []).forEach(pos => {
                const { exchangeToken, tradeTerm, averagePrice, lastPrice, pnl, tradingInstrument, orderType, netQuantity } = pos;
                if (!exchangeToken || !tradeTerm) return;
                const key = `${exchangeToken}_${tradeTerm}`;
                if (!result[key]) {
                    result[key] = {
                        exchangeToken,
                        tradeTerm,
                        tradingInstrument,
                        totalPnl: 0,
                        avgPriceSum: 0,
                        ltpSum: 0,
                        count: 0,
                        netQuantity: 0
                    };
                }
                result[key].totalPnl += pnl || 0;
                result[key].avgPriceSum += averagePrice || 0;
                result[key].ltpSum += lastPrice || 0;
                result[key].count += 1;
                result[key].netQuantity += netQuantity;
            });
            Object.keys(result).forEach(key => {
                const item = result[key];
                item.avgPrice = item.count ? item.avgPriceSum / item.count : 0;
                item.ltp = item.count ? item.ltpSum / item.count : 0;
                item.pl = item.totalPnl;
                item.quantity = item.netQuantity;
                delete item.avgPriceSum;
                delete item.ltpSum;
                delete item.count;
            });
            return result;
        },
        groupedEntryOrders() {
            const result = {};
            this.orders.forEach(order => {
                const { entryOrders, exitOrders, tradeTerm, portfolioName, status } = order;
                if (!tradeTerm) return;
                const tradeTermName = tradeTerm.name;
                if (Array.isArray(entryOrders)) {
                    entryOrders.forEach(entry => {
                        const key = `${entry.exchangeToken}_${tradeTermName}`;
                        if (!result[key]) {
                            result[key] = {
                                portfolios: [],
                                exitPendingDetails: []
                            };
                        }
                        const exists = result[key].portfolios
                            .some(p => p.name === portfolioName && p.status === status);
                        if (!exists) {
                            result[key].portfolios.push({
                                name: portfolioName,
                                status
                            });
                        }
                    });
                }
                if (Array.isArray(exitOrders)) {
                    exitOrders.forEach(exit => {
                        const key = `${exit.exchangeToken}_${tradeTermName}`;
                        if (!result[key]) {
                            result[key] = {
                                portfolios: [],
                                exitPendingDetails: []
                            };
                        }

                        if (exit.executedStatus && exit.executedStatus !== "COMPLETE") {
                            result[key].exitPendingDetails.push({
                                portfolioName,
                                executedStatus: exit.executedStatus,
                                exitType: exit.exitType,
                                brokerOrderRemarks: exit.brokerOrderRemarks,
                                executedDateTime: exit.executedDateTime
                            });
                        }
                    });
                }
            });
            return result;
        },
        groupedBrokerPositions() {
            const result = {};
            (this.brokerPositions || []).forEach(pos => {
                const { exchangeToken, tradeTerm, tradingInstrument, netQuantity } = pos;
                if (!exchangeToken || !tradeTerm) return;
                let positionTradeterm = this.getTradeName(tradeTerm)
                const key = `${exchangeToken}_${positionTradeterm}`;
                if (!result[key]) {
                    result[key] = {
                        exchangeToken,
                        tradeTerm,
                        tradingInstrument,
                        netQuantity: 0
                    };
                }
                result[key].netQuantity += netQuantity;
            });
            Object.keys(result).forEach(key => {
                const item = result[key];
                item.quantity = item.netQuantity;
            });
            return result;
        },
    },
    async mounted() {
        const data = JSON.parse(sessionStorage.getItem('positionUser'));
        this.userId = data.key;
        this.userName = data.name;
        await this.getAnalyticsDataByUserId();
        this.positions = this.analyticsData?.positionBeans || [];
        this.brokerPositions = this.analyticsData?.brokerPositionBeans || [];
        this.orders = this.analyticsData?.orderBeans || [];
        this.totalPnL = this.positions.reduce((sum, pos) => sum + pos.pnl, 0);
    }
};
</script>
